<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <!-- <v-card-title>
            <v-toolbar color="#1f97b9" dark>
                <v-icon>far fa-user</v-icon>
                <v-toolbar-title>PRUEBA EL COTIZADOR EXPRESS AQUI</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-text>(Máximo 5 artículos)</v-toolbar-text>
            </v-toolbar>
        </v-card-title> -->
        <!-- <v-card-actions>
          <v-layout row wrap>
            <v-flex round button-to-express link style="background-color: #1f97b9; color: #FFFFFF;" @click="dialog = false">
                <div style="justify-content: center; align-items: center; text-align:center; margin-top: 20px;">
                    <p>Quiero Cotizar una <br><b style="font-size: 25px;">MUDANZA</b></p>
                </div>
            </v-flex>
            <v-flex sm1></v-flex>
            <v-flex round button-to-express link center style="background-color: #1f97b9; color: #FFFFFF;" @click="goToExpress()">
                <div style="justify-content: center; align-items: center; text-align:center; margin-top: 20px;">
                    <p>Quiero Cotizar un <br><b style="font-size: 25px;">FLETE</b><br> Máximo 5 artículos</p>
                </div>
            </v-flex>
          </v-layout>
        </v-card-actions> -->
        <v-card-actions>
          <v-layout row wrap>
            <v-flex round button-to-express link style="background-color: #1f97b9; color: #FFFFFF;" @click="dialog = false">
                <div style="justify-content: center; align-items: center; text-align:center; margin-top: 20px;">
                    <p><b style="font-size: 25px;">¡ESTAMOS TRABAJANDO A FULL!</b><br/>Tenemos mudanzas disponibles a partir del: <b>{{ getDay() }}</b><br><br> Si quieres planificar tu mudanza con nosotros, haz click <b style="color: red; font-size: large;">aqui</b>.</p>
                </div>
            </v-flex>
            <!-- <v-flex sm1></v-flex> -->
            
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { EventBus } from '../../events.js'
  export default{
    name: 'DialogExpress',
    data () {
      return {
          dialog: true,
      }
    },
    methods:{
      goToExpress() {
        const url = '/Express'
        var win = window.open(url)
      },
      getDay() {
        return this.$moment().add(3, 'days').format("DD-MM-YYYY")
      }
    },
    mounted(){
      EventBus.$on('openLogin', data => {
        this.dialog = data
      })
      EventBus.$on('closeServiceQuestion', data => {
        this.dialog = data
      })
    }
  }
</script>